import { useEffect, useState } from 'react'
import { FiltroBandejaCompleto } from '../../features/bandejaMutuos/models/filtroBandeja';
import { TextField } from '@mui/material'
import { TablaBasicFilter } from '../../utils/tableBasicFilter';

interface tableFilterProps {
  control: controlProps
  placeholder: string
  searchFilter?: string | null
  setFiltros?: React.Dispatch<React.SetStateAction<TablaBasicFilter>>;
}

interface controlProps {
  params: URLSearchParams
  fetchData: (pageParam?: number) => Promise<void>
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
}

let lastUpdate = Date.now();

TableFilterComponent.defaultProps = {
  placeholder: 'Buscar...',
}

export default function TableFilterComponent(props: tableFilterProps) {
  const delay = 1000;
  const [inputValue, setInputValue] = useState<string>(props.searchFilter || '');

  useEffect(() => {
    if (props.searchFilter !== undefined && props.searchFilter !== null) {
      setInputValue(props.searchFilter);
    }
  }, [props.searchFilter]);

  async function customOnChange(event: { target: { value: any } }) {
    const value = event.target.value;
    setInputValue(value);
    lastUpdate = Date.now()

    setTimeout(() => {
      const diff = Date.now() - lastUpdate;
      if (diff > delay) {
        handleSearch(value.toLowerCase());
      }
    }, delay);
  }

  async function handleSearch(search: any) {
    props.control.setLoading(true);

    props.control.params.delete('filters.search');
    props.control.params.append('filters.search', search);

    if (props.setFiltros) {
      props.setFiltros((prev) => ({
        ...prev,
        search: search
      }));
    }

    await props.control.fetchData(0);
  }

  return (
    <TextField
      type="text"
      variant='standard'
      value={inputValue}
      onChange={(val) => customOnChange(val)}
      autoComplete="off"
      // placeholder={props.placeholder}
      label={props.placeholder}
    />
  )
}
